import script from "./CPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./CPagination.vue?vue&type=script&setup=true&lang=ts"

import "./CPagination.vue?vue&type=style&index=0&id=6ca71610&scoped=true&lang=scss"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca71610"]])

export default __exports__